import { Record } from 'immutable';

import { MetadataListEntity } from '../components/metadata-list/metadata-list.entity';

export interface IMetadataState {
	loading: boolean;
	metadataList: MetadataListEntity;
}

export const defaults: IMetadataState = {
	loading: false,
	metadataList: MetadataListEntity.build([]),
};

export const MetadataFeatureKey = 'metadata';

export class MetadataState extends Record<IMetadataState>(defaults) {
	public static key = MetadataFeatureKey;

	public setLoading(isLoading: boolean): MetadataState {
		return this.set('loading', isLoading);
	}

	public setMetadataList(metadataList: MetadataListEntity): MetadataState {
		return this.set('metadataList', metadataList);
	}
}
